<template>
  <div v-if="isShow" class="snapShot">
    <div class="snapShot_content">
      <div class="snapShot_wrapper">
        <img src="https://upload.chongnengjihua.com/common/weixin/no-data.png">
        <div>未授权微信信息，无法进入页面</div>
      </div>
      <p>点击右下方“使用完整服务”授权后即可进入</p>
    </div>
    <div class="snapShot_bottom_click" id="bottom_click"/>
  </div>
</template>

<script>
import lottie from 'lottie-web'
export default {
  data(){
    return {
      isShow:false
    }
  },
  methods:{
    open(){
      this.isShow=true
      this.$nextTick(()=>{
        this.svgFun()
      })
    },
    svgFun(){
      lottie.loadAnimation({
        renderer: "svg",
        loop: true,
        autoplay: true,
        container: document.getElementById('bottom_click'),
        path: 'https://upload.chongnengjihua.com/common/weixin/click.json'
      })
    }
  }
}
</script>

<style scoped>
.snapShot{
  background:#fff;
  position: fixed;
  left:0;
  right:0;
  bottom:0;
  top:0;
  z-index: 999;
}
.snapShot_content{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.3rem;
  color: #333333;
  margin-top:1.36rem;

}
.snapShot_wrapper{
  width: 4.8rem;
  height: 240px;
  position: relative;
  text-align:center;
  margin-bottom: 0.04rem;
}
.snapShot_wrapper div{
  width: 100%;
  position: absolute;
  font-size: 0.32rem;
  font-weight: 500;
  color: #333333;
  line-height: 0.52rem;
  bottom: 0;
}
.snapShot_wrapper img{
  width: 100%;
  height: 100%;
}

.snapShot_bottom_click{
  width: 2.5rem;
  height: 2.32rem;
  position: absolute;
  right:0;
  bottom:0;
}
</style>